import { useTranslation } from 'react-i18next';
import type { AuthRole } from '..';
import useStudioGroup from '../../../hooks/useStudioGroup';

const faqLinks: Record<string, Record<string, string>> = {
  SO: {
    ANONYMOUS: 'https://info.pelckmansportaal.be',
    TEACHER: 'https://info.pelckmansportaal.be/pelckmans-uploads/Pelckmans-Portaal-Handleiding-voor-de-leerkracht.pdf',
    STUDENT: 'https://info.pelckmansportaal.be/pelckmans-uploads/Pelckmans-Portaal-Handleiding-voor-de-leerling.pdf',
  },
  ES: {
    ANONYMOUS: 'https://info.pelckmansportail.be',
    TEACHER: 'https://info.pelckmansportail.be/pelckmans-uploads/Pelckmans-Portail-Manuel-pour-le-professeur.pdf',
    STUDENT: 'https://info.pelckmansportail.be/pelckmans-uploads/Pelckmans-Portail-Manuel-pour-l%27%C3%A9l%C3%A8ve.pdf',
  },
  BAO: {
    ANONYMOUS:
      'https://info.pelckmansportaal.be/pelckmans-uploads/Pelckmans-Leerpoort-Handleiding-voor-de-leerkracht.pdf',
    TEACHER:
      'https://info.pelckmansportaal.be/pelckmans-uploads/Pelckmans-Leerpoort-Handleiding-voor-de-leerkracht.pdf',
  },
  // VO has only teacher manuals and we show the same translations for all roles.
  VO: {
    ANONYMOUS:
      'https://info.pelckmansportaal.be/pelckmans-uploads/Pelckmans-Zogezegd-Handleiding-voor-de-leerkracht.pdf',
    STUDENT: 'https://info.pelckmansportaal.be/pelckmans-uploads/Pelckmans-Zogezegd-Handleiding-voor-de-leerkracht.pdf',
    TEACHER: 'https://info.pelckmansportaal.be/pelckmans-uploads/Pelckmans-Zogezegd-Handleiding-voor-de-leerkracht.pdf',
  },
};

const Link = ({ url, translationKey }: { url: string; translationKey: string }) => {
  const { t } = useTranslation();
  return (
    <p
      className="list-sections__paragraph list-sections__paragraph__link"
      dangerouslySetInnerHTML={{
        __html: t(translationKey, {
          url,
        }),
      }}
    />
  );
};

interface FaqProps {
  authRole: AuthRole;
}

export default function Faq({ authRole }: FaqProps) {
  const studioGroup = useStudioGroup();
  return <Link url={faqLinks[studioGroup][authRole]} translationKey={`PAGES.HELP.SECTIONS.FAQ.${authRole}`} />;
}
